import { Col, DatePicker, Form, Select, Input } from "antd";
import { useEffect, useState } from "react";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";
import CustomDatePicker from "common/CustomDatePicker";

const MachineInformationFilter = ({ initialTableData }) => {
  // States for filter lists
  const [actionTypes, setActionTypes] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [locations, setLocations] = useState([]);
  const [machineLines, setMachineLines] = useState([]);
  const [countries, setCountries] = useState([]);
  const [sewingLines, setSewingLines] = useState([]);

  // Antd
  const { Option } = Select;

  const getFilterPrerequisites = async (filterValues = {}) => {
    const response = await getData(
      `/api/digitalization/machine-maintenance/machine-information/pre-requisites`,
      false,
      null,
    );

    if (response && response?.data?.code === 200) {
      const data = response?.data?.data;

      // Set all dropdown data from the response
      setActionTypes(data?.action_types || []);
      setBrands(data?.brands || []);
      setModels(data?.models || []);
      setLocations(data?.locations || []);
      setMachineLines(data?.machine_lines || []);
      setCountries(data?.countries || []);
      setSewingLines(data?.sewing_lines || []);
    }
  };

  // Effects
  useEffect(() => {
    getFilterPrerequisites();
  }, []);

  return (
    <>
      <Col span={3}>
        <Form.Item label="Machine ID" name="machine_identifier">
          <Input placeholder="Enter Machine ID" size="small" />
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Machine Name" name="machine_name">
          <Input placeholder="Enter Machine Name" size="small" />
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Machine Action Type" name="machine_action_type_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Action Type"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(actionTypes) &&
              actionTypes.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Machine Brand" name="machine_brand_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Brand"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(brands) &&
              brands.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Machine Model" name="machine_model_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Model"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(models) &&
              models.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Machine Location" name="machine_location_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Location"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(locations) &&
              locations.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Machine Line" name="machine_line_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Machine Line"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(machineLines) &&
              machineLines.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Machine Origin" name="machine_origin_country_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Origin Country"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(countries) &&
              countries.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={3}>
        <Form.Item label="Sewing Line" name="sewing_line_id">
          <Select
            showSearch
            allowClear
            placeholder="Select Sewing Line"
            optionFilterProp="children"
            size="small"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {isArrayAndHasValue(sewingLines) &&
              sewingLines.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default MachineInformationFilter;
